import { createBrowserRouter, Navigate } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { InvitePage } from "./pages/InvitePage";
import { ReviewPage } from "./pages/ReviewPage";
import { PostLoginPage } from "./pages/PostLoginPage";
import { AppShell } from "./components/AppShell";
import { Dashboard } from "./pages/workspace/Dashboard";
import { PlaysIndex } from "./pages/workspace/PlaysIndex";
import { PlayWorkspace } from "./pages/workspace/PlayWorkspace";
import { HandsOps } from "./pages/workspace/HandsOps";
import { Forks } from "./pages/workspace/Forks";
import { TemplateStudio } from "./pages/workspace/TemplateStudio";
import { Threads } from "./pages/workspace/Threads";
import { Systems } from "./pages/workspace/Systems";
import { RegulatoryMemory } from "./pages/workspace/RegulatoryMemory";
import { Workforce } from "./pages/workspace/Workforce";
import { Autonomy } from "./pages/workspace/Autonomy";
import { AgentHealth } from "./pages/workspace/AgentHealth";
import { Ledger } from "./pages/workspace/Ledger";
import { RunDetail } from "./pages/workspace/RunDetail";
import { AgentManagement } from "./pages/workspace/AgentManagement";
import { Members } from "./pages/workspace/Members";
import { Settings } from "./pages/workspace/Settings";
import { RedirectToWorkforce } from "./pages/workspace/RedirectToWorkforce";
import { TaskReviewPage } from "./pages/workspace/TaskReviewPage";
import { AdminTenants } from "./pages/admin/AdminTenants";
import { AdminTenantDetail } from "./pages/admin/AdminTenantDetail";
import { AdminAudit } from "./pages/admin/AdminAudit";
import { AppEntry } from "./app/AppEntry";
import { AppShellPwa } from "./app/AppShellPwa";
import { Thread } from "./app/Thread";
import { Queue } from "./app/Queue";
import { Reports } from "./app/Reports";
import { RunInApp } from "./app/RunInApp";

export const router = createBrowserRouter([
  { path: "/", element: <Navigate to="/post-login" replace /> },
  { path: "/login", element: <LoginPage /> },
  { path: "/post-login", element: <PostLoginPage /> },
  { path: "/invites/:token", element: <InvitePage /> },
  { path: "/r/:token", element: <ReviewPage /> },
  // The everyday app (Change SRS v0.4 NEW-UX-1): one link, three tabs.
  { path: "/app", element: <AppEntry /> },
  {
    path: "/app/:workspaceId",
    element: <AppShellPwa />,
    children: [
      { index: true, element: <Navigate to="thread" replace /> },
      { path: "thread", element: <Thread /> },
      { path: "queue", element: <Queue /> },
      { path: "reports", element: <Reports /> },
      { path: "runs/:runId", element: <RunInApp /> },
    ],
  },
  { path: "/admin", element: <Navigate to="/admin/tenants" replace /> },
  { path: "/admin/tenants", element: <AdminTenants /> },
  { path: "/admin/tenants/:tenantId", element: <AdminTenantDetail /> },
  { path: "/admin/audit", element: <AdminAudit /> },
  {
    path: "/workspaces/:workspaceId",
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="dashboard" replace /> },
      { path: "dashboard", element: <Dashboard /> },
      { path: "plays", element: <PlaysIndex /> },
      { path: "plays/:playId", element: <PlayWorkspace /> },
      // "My queue" is the judgement-fork queue. The PlayStudio operator
      // inbox is still reachable at /operator-legacy for now.
      { path: "operator", element: <Forks /> },
      { path: "operator-legacy", element: <HandsOps /> },
      { path: "workforce", element: <Workforce /> },
      { path: "workforce/runs/:runId", element: <RunDetail /> },
      { path: "regulatory", element: <RegulatoryMemory /> },
      { path: "autonomy", element: <Autonomy /> },
      { path: "templates", element: <TemplateStudio /> },
      { path: "threads", element: <Threads /> },
      { path: "systems", element: <Systems /> },
      { path: "agent-health", element: <AgentHealth /> },
      { path: "agents", element: <AgentManagement /> },
      // The Efficiency Ledger replaces PlayStudio's Outcomes page, which
      // counted completed plays in a product that has none.
      { path: "outcomes", element: <Ledger /> },
      { path: "ledger", element: <Ledger /> },
      { path: "people", element: <Members /> },
      { path: "settings", element: <Settings /> },
      // The catalogue these two render is a PlayStudio surface with nothing
      // in it, and "Workforce" in the nav used to point here. A stale tab or
      // an old bookmark lands on an empty page that looks like a broken
      // product, so both now redirect to the roster.
      { path: "hands/library", element: <RedirectToWorkforce /> },
      { path: "hands/my", element: <RedirectToWorkforce /> },
      { path: "tasks/:stepId", element: <TaskReviewPage /> },
    ],
  },
  { path: "*", element: <Navigate to="/" replace /> },
]);
